// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"998":"b498af6ab0c901ea742a","1700":"00701b7eb7f649b4f3c0"}[chunkId] + ".js";
};